import React from 'react'
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'

export default function Footer() {

    const footerNav = [
        {
            id: '1',
            label: 'Instant Loan',
            link: '/services/instant-loan'
        },
        {
            id: '2',
            label: 'Emergency Loan',
            link: '/services/emergency-loan'
        },
        {
            id: '3',
            label: 'Personal Loan',
            link: '/services/personal-loan'
        },
        {
            id: '4',
            label: 'Terms and Condition',
            link: '/terms-and-conditions'
        },
        {
            id: '5',
            label: 'Grievances',
            link: '/grievances'
        },
        {
            id: '6',
            label: 'Fair Practices Code',
            link: '/fair-practice'
        }
    ]

    const quickLink = [
        {
            id: '1',
            label: 'About Us',
            link: '/about-us'
        },
        {
            id: '2',
            label: 'Services',
            link: '/services'
        },
        {
            id: '3',
            label: 'Contact Us',
            link: '/contact-us'
        },
        {
            id: '4',
            label: 'Apply Now',
            link: '/apply-now'
        },
        {
            id: '5',
            label: 'Privacy Policy',
            link: '/privacy-policy'
        },
    ]

    const socialMedia = [
        {
            id: "1",
            icon: <FacebookIcon />,
            link: "https://www.facebook.com/B4Salary"
        },
        {
            id: "2",
            icon: <InstagramIcon />,
            link: "https://www.instagram.com/b4salary/"
        },
        {
            id: "3",
            icon: <YouTubeIcon />,
            link: "https://www.youtube.com/@b4_salary"
        },
        {
            id: "4",
            icon: <LinkedInIcon />,
            link: "https://in.linkedin.com/company/kisga-leasing-and-finance-pvt-ltd?_l=en_US"
        }
    ]

    return (
        <footer className="bg-gradient-to-b from-[#0b1220] to-[#0a0f1a] text-gray-300 py-16 px-6">
            <div className="max-w-7xl mx-auto">

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

                    {/* LEFT SECTION */}
                    <div>
                        <div className="mb-4">
                            <Link to='/'>
                                <img src={logo} alt="Logo" />
                            </Link>
                        </div>

                        <p className="text-sm text-gray-400 leading-relaxed">
                            B4SALARY is owned by Kisga Leasing and Finance Pvt Ltd.,
                            a RBI-registered Non-Banking Financial Company (NBFC).
                            <br />
                            CIN: U74899DL1993PTC053939
                        </p>

                        {/* Social Icons */}
                        <div className="flex gap-4 mt-6">
                            {socialMedia.map((item) => (
                                <a
                                    key={item.id}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition"
                                >
                                    {item.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* LOAN PRODUCTS */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Loan Products</h3>
                        <ul className="space-y-2 text-sm">
                            {footerNav.map((item) => (
                                <li key={item.id} className="py-1">
                                    <Link
                                        to={item.link}
                                        className="hover:text-white transition"
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* COMPANY */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Company</h3>
                        <ul className="space-y-2 text-sm">
                            {quickLink.map((item) => (
                                <li key={item.id} className="py-1">
                                    <Link
                                        to={item.link}
                                        className="hover:text-white transition"
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* CONTACT */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">Contact Us</h3>

                        <ul className="space-y-4 text-sm">
                            <li className="flex items-center gap-3">
                                <EmailIcon fontSize="small" />
                                care@b4salary.com
                            </li>

                            <li className="flex items-center gap-3">
                                <LocalPhoneIcon fontSize="small" />
                                +91-8049368211
                            </li>

                            <li className="flex items-start gap-3">
                                <LocationOnIcon fontSize="small" />
                                <span>
                                    Registered Office: C-31, DSIDC, Rohtak Road Industrial Complex,
                                    Nangloi, Delhi - 110041, India
                                </span>
                                
                            </li>
                            <li className="flex items-start gap-3">
                             <LocationOnIcon fontSize="small" />
                                <span>
                                  Office: B-7, New Multan Nagar, Paschim Vihar, New Delhi - 110056
                                </span>
                            </li>
                        </ul>
                    </div>

                </div>

                {/* BOTTOM BAR */}
                <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
                    <Link to="https://kisgaleasing.com" target='_blank'>
                    <p>
                        © Kisga Leasing and Finance Pvt Ltd. All rights reserved.
                    </p>
                    </Link>

                    <div className="flex gap-6 mt-4 md:mt-0">
                        <Link to="/privacy-policy" className="hover:text-white transition">
                            Privacy Policy
                        </Link>

                        <Link to="/terms-and-conditions" className="hover:text-white transition">
                            Terms & Conditions
                        </Link>
                    </div>
                </div>

            </div>
        </footer>
    )
}